import React from 'react'
import { FormWrapperProps } from '../components/form/form-wrapper'
import { UseMutationResult } from '../queries'
import { extractApiError, ApiError } from '../api'

export const useFormWrapperPropsWithMutationData = (
  props: FormWrapperProps,
  mutation?: UseMutationResult<any, any>,
  disabled?: boolean,
): FormWrapperProps =>
  React.useMemo(
    () => ({
      status: mutation?.status,
      ...props,
      disabled,
      successProps: { ...(props.successProps || {}), data: mutation?.data },
      errorProps: {
        ...(props.errorProps || {}),
        extracted: mutation?.error ? extractApiError(mutation.error as ApiError) : undefined,
      },
    }),
    [props, mutation],
  )
